
import { $appConfig } from '@/config/app.js'

// Env check
export function isDebug() {
   return $appConfig.app.env === 'debug'
}
